import React from 'react';
import Axios from 'axios';
import BlockingLoader from '../../common/form/blocking-loader';
import { Heading } from '../../common/form/form-parts';
import { FormFooterLogo } from 'tradera/apps/registration/components/common/form/form-footer-logo';

export class SwedishPrivateWaitForAccountCreation extends React.Component {
    componentDidMount() {
        this.checkStatus();
    }

    componentWillUnmount() {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
    }

    checkStatus() {
        const successData = this.props.successfulSubmissionData || {};
        Axios.get(`/register/api/account/status/${successData.memberId}`)
            .then((resp) => {
                switch (resp.data) {
                    case 'Pending':
                        this.timeout = setTimeout(
                            this.checkStatus.bind(this),
                            500
                        );
                        return;
                    case 'ManualReview':
                        this.props.onManualReview();
                        return;
                    case 'Approved':
                        this.props.onNavigate();
                        return;
                    default:
                        this.props.onManualReview();
                        return;
                }
            })
            .catch(() => {});
    }

    render() {
        return (
            <>
                <div />
                <div className={'mt-7'}>
                    <Heading>Ditt konto skapas</Heading>
                    <div className="blocking-loader-container mb-5">
                        <BlockingLoader />
                    </div>
                    <div className={'text-center mb-3'}>
                        Har du problem?{' '}
                        <a href={this.props.helpUrl}>Kontakta oss</a>
                    </div>
                </div>
                <div className="text-center mb-4">
                    <FormFooterLogo />
                </div>
            </>
        );
    }
}
